import ga4 from "@/lib/tracking/ga4Core";

export const trackExploreAqarPlus = ({ journey, source }) => {
  const eventName = "click_interaction";

  const eventParams = {
    target: "explore_aqar_plus_features",
    journey_details: journey,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
